import React, { useEffect, useState } from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import CommercialInvoiceForm from "MODULES/shared/components/CommercialInvoice/Form";
import LineItemsForm from "MODULES/shared/components/CommercialInvoice/Form/FormSections/LineItemsForm";
import { mapSOToForm } from "MODULES/SalesOrders/helpers";
import CommercialDiscreetButton from "MODULES/shared/components/CommercialInvoice/Form/CommercialDiscreetButton";
import SaveWarning from "MODULES/shared/components/CommercialInvoice/Form/FormSections/SaveWarning";

import {
  Close,
  Header,
  Modal as ReactModal
} from "../../../../../shared/components/Modal";
import {
  setInvoiceInitialValues,
  addLineItemsFunc,
  COMMERCIAL_INVOICE,
  COMMERCIAL_INVOICE_LINE_ITEMS,
  SAVE_OR_REPLACE_FORM
} from "../../../../../shared/components/CommercialInvoice/helpers";

export function Modal({ shippingRecord, open, close }) {
  const [lineItems, setLineItems] = useState([]);
  const [salesOrder, setSalesOrder] = useState({ so: [] });
  const [currentForm, setCurrentForm] = useState(COMMERCIAL_INVOICE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.salesOrders.show(shippingRecord.reference_record_id).then(resp => {
      setSalesOrder(resp.data);
      const result = resp.data.line_items;
      setLineItems([result[0].inventory]);
      if (result.length > 1) {
        setCurrentForm(COMMERCIAL_INVOICE_LINE_ITEMS);
      }
      setLoading(false);
    });

    return function cleanup() {};
  }, []);

  const invoiceInitialValues = setInvoiceInitialValues({
    lineItems,
    shippingRecord,
    salesOrder: mapSOToForm(salesOrder)
  });

  invoiceInitialValues.shipment_id = shippingRecord.id;
  invoiceInitialValues.has_commercial_invoice_attachment =
    shippingRecord.has_commercial_invoice_attachment;

  if (!shippingRecord.has_commercial_invoice_attachment) {
    invoiceInitialValues.replace_pdf = true;
  }

  const addLineItems = addLineItemsFunc({ setLineItems, setCurrentForm });

  return (
    <ReactModal
      key={shippingRecord.id}
      open={open}
      close={close}
      dialogClass="modal-lg"
    >
      <Header>
        <CommercialDiscreetButton
          display={currentForm === COMMERCIAL_INVOICE}
        />
        <Close close={close} />
        <h4 className="modal-title">Create Commercial Invoice</h4>
      </Header>
      <Body
        close={close}
        addLineItems={addLineItems}
        lineItems={salesOrder.line_items}
        currentForm={currentForm}
        loading={loading}
        salesOrderId={shippingRecord.reference_record_id}
        invoiceInitialValues={invoiceInitialValues}
        hazmat={shippingRecord.hazmat}
        discreet={shippingRecord.discreet}
        setCurrentForm={setCurrentForm}
      />
    </ReactModal>
  );
}

const Body = ({
  addLineItems,
  close,
  currentForm,
  discreet,
  hazmat,
  lineItems,
  loading,
  invoiceInitialValues,
  salesOrderId,
  setCurrentForm
}) => {
  if (loading) {
    return <div className="animate-form-body" />;
  } else if (currentForm === COMMERCIAL_INVOICE_LINE_ITEMS) {
    return (
      <LineItemsForm
        close={close}
        addLineItems={addLineItems}
        lineItems={lineItems}
        enableReinitialize
      />
    );
  } else if (currentForm === SAVE_OR_REPLACE_FORM) {
    return <SaveWarning close={close} setCurrentForm={setCurrentForm} />;
  }
  return (
    <CommercialInvoiceForm
      close={close}
      initialValues={invoiceInitialValues}
      hazmat={hazmat}
      discreet={discreet}
      salesOrderId={salesOrderId}
      enableReinitialize
      setCurrentForm={setCurrentForm}
    />
  );
};

Body.propTypes = {
  addLineItems: T.func,
  close: T.func,
  currentForm: T.string,
  hazmat: T.bool,
  discreet: T.bool,
  invoiceInitialValues: T.shape({}),
  loading: T.bool,
  lineItems: T.arrayOf(T.shape({})),
  lineItemsForm: T.shape({}),
  salesOrderId: T.number
};

Modal.propTypes = {
  close: T.bool,
  shippingRecord: T.shape({}),
  open: T.bool
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Actions/CreateCommercialInvoice/Modal.jsx